import {UiCard, UiNotice} from '@morefunos/ui';

export interface PlaceholderPageProps {
  readonly title: string;
  readonly description: string;
}

export function PlaceholderPage({title, description}: PlaceholderPageProps) {
  return (
    <section className="smm-page smm-placeholder" aria-labelledby={`smm-${title}`}>
      <div className="smm-section-heading">
        <p className="smm-eyebrow">MoreFun SMM</p>
        <h1 id={`smm-${title}`}>{title}</h1>
      </div>
      <UiCard className="smm-placeholder-card">
        <UiNotice tone="info" role="status">
          {description}
        </UiNotice>
        <p className="smm-muted">
          呢個入口已預留，但未有已驗證嘅 Business consumer 前唔會顯示假資料或假操作。
        </p>
      </UiCard>
    </section>
  );
}
